export const CardType = {
    TEAM: 'Favorite Team Card',
    CATEGORY: 'Category Card',
};
